import { AppointmentEvent } from 'types'
import { TranslateFunction } from './translate'

export const getStatusText = (status: string, __ : TranslateFunction) => {
    switch(status){
        case 'pending':
        case 'paid':
        case 'cancelled':
        case 'refunded':
            return __(status)
        default:
            return status
    }
}

export const getStatusType = (status: string) => {
    switch(status){
        case 'pending':
            return 'warning'
        case 'paid':
            return 'success'
        case 'cancelled':
            return 'danger'
        default:
            return 'disable'
    }
}

export const getActionText = (events: AppointmentEvent[], __ : TranslateFunction) => {
    if(events.length > 0 && events.find(e => e.type === 'CUSTOMER_CHECKIN')){
        return __('check_in')
    }
    if(events.length > 0 && events.find(e => e.type === 'NO_SHOW')){
        return __('no_show')
    }
    return null
}

export const getActionType = (events: AppointmentEvent[]) => {
    if(events.length > 0 && events.find(e => e.type === 'CUSTOMER_CHECKIN')){
        return 'success'
    }
    if(events.length > 0 && events.find(e => e.type === 'NO_SHOW')){
        return 'danger'
    }
}
